import { DETERMINAR_PAGINA_ATUAL_ITINERARIO_EMBARQUE } from '../types'

export default function determinarPaginaAtualItinerarioEmbarque (paginaAtual) {
    return {
      type: DETERMINAR_PAGINA_ATUAL_ITINERARIO_EMBARQUE,
      payload: paginaAtual
    }
}